<script>
    import {push} from 'svelte-spa-router';
    import {onMount} from 'svelte';
    import {data} from '../store';
    import {fade} from 'svelte/transition';
    onMount(()=>{
        if ($data.local == undefined || $data.local == ""){
            push('/');
        }
        if ($data.url != undefined && $data.url != ""){
            setTimeout(function(){
                $data.nombre = undefined;
                $data.documento = undefined;
                $data.fecha = {dia:undefined,mes:undefined,ano:undefined};
                $data.mayor = {fecha:{dia:undefined,mes:undefined,ano:undefined}};
                $data.telefono = undefined;
                $data.instagram = undefined;
                $data.respuestas = [];
                $data.firma = undefined;
                push(`/${$data.url}`);
            }, 3000);
        }
        
    })
</script>
<div class="flex flex-col items-center justify-start w-full h-full p-4" in:fade="{{duration: 500}}">
    <h1 class="font-bold text-3xl text-center">Gracias por finalizar el formulario.</h1>
</div>